import React from "react";
import { useIntl } from "react-intl";
import NumberFormat from "react-number-format";
import { CustomInputLabel } from "src/app/components/CustomInput/CustomInput";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

export const emptyRange = { min: null, max: null };

export default function CustomFollowersRange({
  customRange,
  setCustomRange,
  disabled,
}) {
  const intl = useIntl();

  const handleValueChange = (setValueFn) => (newValue) => {
    const { floatValue } = newValue;
    setValueFn(floatValue ?? null);
  };

  const setRangeFrom = (value) => {
    setCustomRange((prev) => {
      if (prev.length === 0) {
        return [{ ...emptyRange, min: value }];
      }
      return [{ ...prev[0], min: value }];
    });
  };

  const setRangeTo = (value) => {
    setCustomRange((prev) => {
      if (prev.length === 0) {
        return [{ ...emptyRange, max: value }];
      }
      return [{ ...prev[0], max: value }];
    });
  };

  const basicValidation = (values) => {
    const { floatValue } = values;

    if (floatValue === undefined || floatValue === null) {
      return true;
    }

    if (typeof floatValue !== "number" || Number.isNaN(floatValue)) {
      return false;
    }

    if (floatValue <= 0 || floatValue > Number.MAX_SAFE_INTEGER) {
      return false;
    }

    return true;
  };

  const validateRangeTo = (value) => {
    if (customRange.min !== null) {
      return value > customRange.min;
    }
    return true;
  };

  const validateRangeFrom = (value) => {
    if (customRange.max !== null) {
      return value < customRange.max;
    }
    return true;
  };

  return (
    <div className="audience-search__field-wrap">
      <div className="audience-search__field-columns">
        <div className="audience-search__field-col-1">
          <CustomInputLabel htmlFor="range-from">
            <IDHFormattedMessage id="front_from" defaultMessage="From" />
          </CustomInputLabel>
          <NumberFormat
            id="range-from"
            value={customRange.min}
            onValueChange={handleValueChange(setRangeFrom)}
            onBlur={() => {
              const isValid = validateRangeFrom(customRange.min);
              if (!isValid) {
                setRangeFrom(customRange.max - 1);
              }
            }}
            thousandSeparator=" "
            className="ws-input"
            placeholder={intl.formatMessage({
              id: "front_enter_value",
              defaultMessage: "Enter value",
            })}
            isAllowed={basicValidation}
            disabled={disabled}
          />
        </div>
        <div className="audience-search__field-col-1">
          <CustomInputLabel htmlFor="range-to">
            <IDHFormattedMessage id="front_to" defaultMessage="To" />
          </CustomInputLabel>
          <NumberFormat
            id="range-to"
            value={customRange.max}
            onValueChange={handleValueChange(setRangeTo)}
            onBlur={() => {
              const isValid = validateRangeTo(customRange.max);
              if (!isValid) {
                setRangeTo(customRange.min + 1);
              }
            }}
            thousandSeparator=" "
            className="ws-input"
            placeholder={intl.formatMessage({
              id: "front_enter_value",
              defaultMessage: "Enter value",
            })}
            isAllowed={basicValidation}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
}
